export const cabecalhos = [
  { text: "Nome Cliente", value: "descricao_linha" },
  { text: "Data Últ. Venda", value: "data_ultima_venda" },
  { text: "Qtde. dias últ. venda", value: "qtde_dias_ultima_venda", is_number: true, sufix: 'dias' },
  { text: "Faturamento Total", value: "faturamento_em_preco_custo", is_money: true },
  { text: "Faturamento Total %", value: "faturamento_em_percentual", is_number: true, sufix: '%' },
  { text: "Saldo de Estoque", value: "estoque", is_number: true },
  { text: "Saldo de Estoque (R$ custo)", value: "estoque_em_preco_custo", is_money: true },
]
